import ScanResult from 'Pages/Admin/SkinAnalyser/SkinAnalyserDetail/ScanResult';

const UserDetail = () => {
  return <ScanResult enterprise={true} />;
};

export default UserDetail;
